const removeName = (value: Record<any, any>) => {
  if (value && value.name) {
    const { name, ...rest } = value;
    return {
      ...rest,
    };
  }

  return value;
};

const rollup = (facet: Record<any, any>) => {
  const values = facet.values.map(removeName).map(value => ({
    [facet.field]: value,
  }));

  return {
    [facet.type || 'any']: values,
  };
};

// adapts filters being sent for what is expected
export const adaptFilters = (filters: Array<any>) => {
  if (!filters || filters.length === 0) return {};
  const all = filters.map(rollup);
  return {
    all,
  };
};
